import React from "react";
import AboutHero from "../components/about-us/AboutHero";
import AboutSection1 from "../components/about-us/AboutSection1";

const AboutUs = () => {
  return (
    <div className="font-lato bg-white ">
      <AboutHero />
      <AboutSection1 />
    </div>
  );
};

export default AboutUs;
